import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { CommonFunctions } from "../static/common-functions";
import { CommonValues } from "../static/CommonValues";
import { v_LocationDetailBus } from "./v_LocationDetailBus";
import { CDocument } from "./CDocument";

export class VehicleMaintenanceHistoryBus extends BaseBus {

    constructor(busObj: VehicleMaintenanceHistoryBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.mileageNumb = parseInt(this.mileage);
    }
    
    vehicleMaintHistId: string;
    recordTypeId: number;
    recordTypeDescription: string;
    note: string;
    recordDt: Date;
    vehicleId: string;
    mileage: string;
    mileageNumb: number;
    haveReceipt: boolean;
    amount: number;
    companyId: string;
    gallons: number;
    mpg: number;
    sentToPayroll: boolean;
    reimburse: boolean;
    approved: boolean;
    approvedUserId: string;
    approvedDt: Date;
    idMatchNumber: string;
    merchantName: string;
    merchantAddress: string;
    merchantCity: string;
    acceptLocation: string;
    vehicleMaintHistImgId: any;
    attachmentDetailFullName: string;
    attachment: any;
    attachmentType: string;
    attachmentName: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    dummy: any;
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
    }

    CID(): any {
        return this.vehicleMaintHistId;
    }
   
    //public setFromForm(busObj: any) {
    //    this.vehicleMaintHistId = busObj.vehicleMaintHistId;
    //    this.recordTypeId = busObj.recordTypeId || 2;
    //    this.note = busObj.note || '';
    //    this.recordDt = busObj.recordDt;
    //    this.vehicleId = busObj.vehicleId;
    //    this.mileage = busObj.mileage;
    //    this.haveReceipt = busObj.haveReceipt;
    //    this.amount = busObj.amount;
    //    this.companyId = busObj.companyId;
    //    this.gallons = busObj.gallons;
    //    this.mpg = busObj.mpg;
    //    this.sentToPayroll = busObj.sentToPayroll;
    //    this.reimburse = busObj.reimburse;
    //    this.approved = busObj.approved;
    //    this.approvedUserId = busObj.approvedUserId;
    //    this.approvedDt = busObj.approvedDt;
    //    this.idMatchNumber = busObj.idMatchNumber;
    //    this.merchantName = busObj.merchantName;
    //    this.merchantAddress = busObj.merchantAddress;
    //    this.merchantCity = busObj.merchantCity;
    //    this.acceptLocation = busObj.acceptLocation;
    //    this.attachmentDetailFullName = busObj.attachmentDetailFullName;
    //    this.insertDt = busObj.insertDt;
    //    this.insertUserId = busObj.insertUserId;
    //    this.updateDt = busObj.updateDt;
    //    this.updateUserId = busObj.updateUserId ;
    //}
}
